/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiResultOfMapOfstringAndint
 */
export interface ApiResultOfMapOfstringAndint {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ApiResultOfMapOfstringAndint
     */
    data?: { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndint
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfMapOfstringAndint
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndint
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndint
     */
    result?: ApiResultOfMapOfstringAndintResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfMapOfstringAndintResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfMapOfstringAndintFromJSON(json: any): ApiResultOfMapOfstringAndint {
    return ApiResultOfMapOfstringAndintFromJSONTyped(json, false);
}

export function ApiResultOfMapOfstringAndintFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfMapOfstringAndint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfMapOfstringAndintToJSON(value?: ApiResultOfMapOfstringAndint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

